export const AUTHORITY = process.env.REACT_APP_AUTHORITY!;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID!;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI!;
export const POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI!;
export const ADMINISTRATOR_API_URL = process.env.ZP_PLATFORM_ADMINISTRATOR_API_URL!;
export const ENV = process.env.ENV!;
